import Select2Controller from '../select2_controller';

export default class extends Select2Controller {
  defaultOptions() {
    return {
      ...super.defaultOptions(),
      placeholder: 'Assign players…',
      allowClear: true,
      closeOnSelect: false,
    };
  }
}

